import { render, staticRenderFns } from "./holidaysList.vue?vue&type=template&id=2141881c&scoped=true&"
import script from "./holidaysList.vue?vue&type=script&lang=js&"
export * from "./holidaysList.vue?vue&type=script&lang=js&"
import style0 from "./holidaysList.vue?vue&type=style&index=0&id=2141881c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141881c",
  null
  
)

export default component.exports